export default "__VITE_ASSET__CHsFahxM__"